import type { ReactNode } from "react";

import { Navigate } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";

/**
 * ⚠ Presentation, not protection.
 *
 * This keeps a signed-out person from seeing a half-rendered screen. It is NOT what stops
 * them reading data — every endpoint authenticates and authorises on its own, and the row
 * scoping happens in the query. A client-side guard is a courtesy to the user, never a
 * security boundary: anyone can edit the JavaScript running in their own browser.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  if (state.status === "loading") return null;
  if (state.status !== "authenticated") return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function AdminRoute({ children }: { children: ReactNode }) {
  const { state, isAdmin } = useAuth();
  if (state.status === "loading") return null;
  if (state.status !== "authenticated") return <Navigate to="/" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
